<div class="feedback-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">Share feedback</h2>
    <button type="button" mat-icon-button disableRipple (click)="onCancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    @switch (loadState) {
      @case ('loading') {
        <div class="dialog-status">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }
      @case ('error') {
        <div class="dialog-status">
          <mat-icon class="dialog-status__icon">error_outline</mat-icon>
          <p class="dialog-status__message">
            We couldn't load the feedback form. Please try again.
          </p>
          <button type="button" mat-stroked-button (click)="loadCategories()">
            Retry
          </button>
        </div>
      }
      @default {
        <p class="dialog-subtitle">
          Tell us what's working well or what we could improve.
        </p>

        <form [formGroup]="feedbackForm" (ngSubmit)="onSubmit()">
          <section class="form-section">
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              hideRequiredMarker
              class="category-field"
            >
              <mat-label>What's this about?</mat-label>
              <mat-select formControlName="category" panelClass="feedback-select-panel">
                @for (option of categories; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </section>

          <section class="form-section">
            <h3 class="section-title">Tell us more</h3>
            <textarea
              class="feedback-textarea"
              [class.has-error]="
                feedbackForm.get('message')?.invalid &&
                feedbackForm.get('message')?.touched
              "
              formControlName="message"
              rows="9"
              maxlength="4000"
              placeholder="Share your feedback..."
            ></textarea>
            @if (
              feedbackForm.get('message')?.hasError('required') &&
              feedbackForm.get('message')?.touched
            ) {
              <p class="error-message">Please enter your feedback.</p>
            }
          </section>
        </form>
      }
    }
  </mat-dialog-content>

  @if (loadState === 'ready') {
    <div class="dialog-actions">
      <button
        type="button"
        mat-raised-button
        class="send-button"
        (click)="onSubmit()"
        [disabled]="feedbackForm.invalid || !feedbackForm.dirty || isSaving"
      >
        @if (isSaving) {
          <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
        }
        Send
      </button>
    </div>
  }
</div>
